import React from 'react';
import Title from 'components/title';
import { RouteComponentProps, navigate } from '@reach/router';
import { useDropzone } from 'react-dropzone';
import ImageTable from './components/imageTable';
import { StoreContext } from 'stores/index';
import { Button } from '@mui/material';
import ActivityIndicator from 'components/activityIndicator';
import { observer } from 'mobx-react-lite';

export interface AddNewsImageProps extends RouteComponentProps {
	newsId: string;
}

const AddNewsImage: React.FunctionComponent<AddNewsImageProps> = observer((props) => {
	const [files, setFiles] = React.useState(new Array<File>());
	const [uploading, setUploading] = React.useState(false);
	const [progress, setProgress] = React.useState(0);
	const { newsStore } = React.useContext(StoreContext);
	const news = newsStore.get_news(props.newsId);

	const onDrop = (acceptedFiles: File[]) => {
		setFiles([...files, ...acceptedFiles]);
	};

	const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

	if (!news) {
		return <ActivityIndicator />;
	}

	if (uploading) {
		return <ActivityIndicator message={`Tilføjer billeder: ${progress}%`} />;
	}

	return (
		<React.Fragment>
			<Title>{`Tilføj billede til nyhed: ${news.title}`}</Title>
			<div {...getRootProps()}>
				<input {...getInputProps()} accept="image/*" />
				{isDragActive ? (
					<p>Placer filerne her ...</p>
				) : (
					<p>Træk billederne til lot'et her - ellers tryk for at vælge dem i en dialog</p>
				)}
			</div>

			{files.length > 0 && <ImageTable files={files} setFiles={setFiles} />}

			{files.length > 0 && (
				<Button
					style={{ marginTop: '1em' }}
					variant="outlined"
					onClick={async () => {
						setUploading(true);
						await newsStore.add_images(props.newsId, files, (completed, total) => {
							setProgress(Math.round((completed / total) * 100));
						});

						navigate(`/news/${props.newsId}`);
						setUploading(false);
					}}
				>
					Tilføj billeder
				</Button>
			)}
		</React.Fragment>
	);
});

export default AddNewsImage;
